
import React, { useState, useCallback } from 'react';
import { ArrowUpFromBracketIcon } from './Icons'; // Changed from UploadIcon

interface FileUploadProps {
  onFileLoad: (file: File) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileLoad }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      onFileLoad(event.target.files[0]);
    }
  };

  const handleDragEnter = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleDrop = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      onFileLoad(event.dataTransfer.files[0]);
    }
  }, [onFileLoad]);

  return (
    <div
      className={`w-full max-w-lg p-8 border-2 border-dashed rounded-xl transition-all duration-300
                  ${isDragging ? 'border-violet-600 bg-violet-50 shadow-2xl scale-105' : 'border-gray-300 hover:border-violet-500 hover:bg-gray-50'}`}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        type="file"
        id="fileInput"
        className="hidden"
        accept=".har,application/json"
        onChange={handleFileChange}
      />
      <label htmlFor="fileInput" className="cursor-pointer flex flex-col items-center justify-center text-center">
        <ArrowUpFromBracketIcon className={`h-16 w-16 mb-4 transition-colors duration-300 ${isDragging ? 'text-violet-500' : 'text-gray-400'}`} />
        <p className={`text-xl font-semibold mb-2 ${isDragging ? 'text-violet-600' : 'text-gray-700'}`}>
          Drag & drop your HAR file here
        </p>
        <p className={`text-sm mb-4 ${isDragging ? 'text-violet-500' : 'text-gray-500'}`}>
          or click to select a file
        </p>
        <div
          className="text-white btn"
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#8238E0')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = isDragging ? '#8238E0' : '#9747FF')}
        >
          <span>Browse File</span>
        </div>
         <p className="mt-4 text-xs text-gray-400">.har or .json files accepted</p>
      </label>
    </div>
  );
};

export default FileUpload;